import { InboxOutlined } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import moment from "moment";
import WidgetList from "../../dashboard/components/WidgetList";
import { MmTradeRecord } from "../types/mm-trade-record.type";
import { formatNumberWithSeparator } from "../../../utils/number-utils";

interface IProps {
  trades: MmTradeRecord[];
  isLoading: boolean;
}

const renderHeader = () => (
  <div className="flex-1 text-center flex items-center pl-2 pr-20">
    <span className="flex-1">Time</span>
    <span className="flex-1 text-right">Value(USDT)</span>
    <span className="flex-1 text-right">Price(USDT)</span>
    <span className="flex-1 text-right">Amount(EXIM)</span>
  </div>
);

const renderItem = (trade: MmTradeRecord) => {
  return (
    <div className="flex-1 text-center flex items-center pl-2 pr-20">
      <span className="flex-1">
        <span className="text-text-2">
          {moment(trade.fillTime).format("YYYY-MM-DD")}
        </span>{" "}
        {moment(trade.fillTime).format("HH:mm:ss")}
      </span>
      <span className="flex-1 text-right">
        {formatNumberWithSeparator(trade.fillQuantity * trade.fillPrice, {
          minimumFractionDigits: 5,
          maximumFractionDigits: 5,
        })}
      </span>
      <span className="flex-1 text-right">
        {formatNumberWithSeparator(trade.fillPrice, {
          minimumFractionDigits: 5,
          maximumFractionDigits: 5,
        })}
      </span>
      <span className="flex-1 text-right">
        {formatNumberWithSeparator(trade.fillQuantity, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </div>
  );
};

export default function CexLatestTradesList({ trades, isLoading }: IProps) {
  return (
    <div className="flex-1">
      <WidgetList
        itemsContainerClassName="max-h-[412px] overflow-y-auto"
        items={trades}
        getKey={(trade) => trade.tradeId}
        renderHeader={renderHeader}
        renderItem={renderItem}
        renderEmpty={() =>
          isLoading ? (
            <div className="mt-24 w-full flex justify-center">
              <CircularProgress size={20} />
            </div>
          ) : (
            <div className="mt-24 w-full flex justify-center gap-1 opacity-75">
              <InboxOutlined /> No trades found
            </div>
          )
        }
      />
    </div>
  );
}
